import { faChevronRight } from "@jewlr/pro-light-svg-icons/faChevronRight"
import { Box, Flex, Typography, FontAwesomeIcon } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import styled from "styled-components"

import {
  sizeChart as getSizeChart,
  averageRingSize as getAverageRingSize,
} from "areas/info/jewlr/ring-sizing/data"

const Table = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
`
const LabelTableData = styled.td`
  min-width: 130px;
  padding: 5px;
  ${(props) =>
    props.border &&
    `
    border-bottom: 1px solid #ccc;
  `}
`
const ChartTableData = styled(Box).attrs((props) => ({
  as: "td",
  p: `5px 10px ${props.pb ? props.pb : "5px"}`,
  ...props,
}))`
  font-weight: 300;
  text-align: center;
  ${(props) =>
    props.border &&
    `
    border-bottom: 1px solid #ccc;
    padding: 5px 4px;
  `}
`
const ChartWrapper = styled.div`
  overflow-x: auto;
`
const StyledLink = styled(Typography).attrs({
  as: Link,
})`
  align-items: center;
  color: ${(props) => props.theme.colors.primary};
  display: inline-flex;
`
const SizeChart = () => {
  const sizeChart = getSizeChart()
  const averageRingSize = getAverageRingSize()
  return (
    <Box p="16px">
      <Flex mb="10px">
        {/* Tabel labels */}
        <Table>
          <tbody>
            <tr>
              <LabelTableData border>
                <strong>Ring Size</strong>
              </LabelTableData>
            </tr>
            <tr>
              <LabelTableData>
                <div>
                  <strong>Diameter (MM)</strong>
                </div>
                <div>Distance across</div>
              </LabelTableData>
            </tr>
            <tr>
              <LabelTableData>
                <div>
                  <strong>Circumference (MM)</strong>
                </div>
                <div>Distance around</div>
              </LabelTableData>
            </tr>
          </tbody>
        </Table>
        {/* Chart */}
        <ChartWrapper data-horizontal-scroll="true">
          <Table>
            <tbody>
              <tr>
                {sizeChart.map((size) => (
                  <ChartTableData border key={`size${size.size}`}>
                    {size.size}
                  </ChartTableData>
                ))}
              </tr>
              <tr>
                {sizeChart.map((size) => (
                  <ChartTableData key={`diameter${size.diameter}`} pb="22px">
                    {size.diameter}
                  </ChartTableData>
                ))}
              </tr>
              <tr>
                {sizeChart.map((size) => (
                  <ChartTableData
                    key={`circumference${size.circumference}`}
                    pb="22px"
                  >
                    {size.circumference}
                  </ChartTableData>
                ))}
              </tr>
            </tbody>
          </Table>
        </ChartWrapper>
      </Flex>
      <Box borderTop="1px solid #ccc" mb={3} pt={1}>
        <Typography variant="body-sm">
          The average ring size for women is size {averageRingSize.women}; the
          average ring size for men is size {averageRingSize.men}.
        </Typography>
        <Typography variant="body-sm">
          A ring should fit secure enough so that it will never fall off. It
          should have a loose comfortable fit when sliding it over your knuckle.
        </Typography>
      </Box>
      <StyledLink data-lc="size-guide" to="/info/ring_sizing">
        Read our full resizing policy{" "}
        <FontAwesomeIcon fontSize="14px" icon={faChevronRight} ml="4px" />
      </StyledLink>
    </Box>
  )
}
SizeChart.propTypes = {
  averageRingSize: PropTypes.object,
  sizeChart: PropTypes.array,
}

export default SizeChart
